import { render, staticRenderFns } from "./ExtraFieldsEdit.vue?vue&type=template&id=24aafaa0"
import script from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24aafaa0')) {
      api.createRecord('24aafaa0', component.options)
    } else {
      api.reload('24aafaa0', component.options)
    }
    module.hot.accept("./ExtraFieldsEdit.vue?vue&type=template&id=24aafaa0", function () {
      api.rerender('24aafaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/ExtraFieldsEdit.vue"
export default component.exports